import { render, staticRenderFns } from "./TopUserTracks.vue?vue&type=template&id=2bb3aa12&scoped=true&"
import script from "./TopUserTracks.vue?vue&type=script&lang=js&"
export * from "./TopUserTracks.vue?vue&type=script&lang=js&"
import style0 from "./TopUserTracks.vue?vue&type=style&index=0&id=2bb3aa12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3aa12",
  null
  
)

export default component.exports